<template>
  <div id="loading">
    <img src="~@/assets/img/loading.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
#loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  // background-color: rgba(0,0,0,0.7);
  z-index: 99999999;
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100px;
    margin-top: -100px;
    transform: translate(-50%, -50%);
  }
}
</style>
